export default async (context) => {
    context.loading = true

    context.auth_counter_time(context)

    await context.auth_phone_get(context, { redirect: false })

    context.loading = false
}